import user from "./user";
import pagination from "./pagination";
import app from "@/store/mutations/app"

export default {
  ...user,
  ...pagination,
  ...app
};
